"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var kendo_react_inputs_1 = require("@progress/kendo-react-inputs");
var reactstrap_1 = require("reactstrap");
var serialize = function (obj) {
    var str = [];
    for (var p in obj)
        if (obj.hasOwnProperty(p)) {
            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
        }
    return str.join("&");
};
var PostCard = /** @class */ (function (_super) {
    __extends(PostCard, _super);
    function PostCard(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            ddlState: [],
            SenderFName: _this.props.registrantFname,
            SenderLName: _this.props.registrantLname,
            SenderEmail: _this.props.registraintEmail,
            SenderZipcode: _this.props.registrantZipCode,
            RecipientFName: '',
            RecipientLName: '',
            RecipientAddress1: '',
            RecipientAddress2: '',
            RecipientCity: '',
            RecipientState: '',
            RecipientZipcode: '',
            lblResult: '',
            SenderEventId: _this.props.registrantsUniqueIdEvent
        };
        fetch('api/ListItems/State')
            .then(function (response) { return response.json(); })
            .then(function (list) {
            _this.setState({ ddlState: list });
        }).catch(function (error) {
            console.log(error);
        });
        _this.SendPostcard = _this.SendPostcard.bind(_this);
        _this.handleCancel = _this.handleCancel.bind(_this);
        _this.validate = _this.validate.bind(_this);
        _this.Clear = _this.Clear.bind(_this);
        return _this;
    }
    ;
    PostCard.prototype.componentDidMount = function () {
        //SenderZipcode
        var senderZipcode = document.getElementById("senderZipcode");
        if (senderZipcode != null) {
            var attZipcode = document.createAttribute("inputmode");
            attZipcode.value = "numeric";
            senderZipcode.setAttributeNode(attZipcode);
        }
        //RecipientZipcode
        var recipientZipcode = document.getElementById("recipientZipcode");
        if (recipientZipcode != null) {
            var attZipcode = document.createAttribute("inputmode");
            attZipcode.value = "numeric";
            recipientZipcode.setAttributeNode(attZipcode);
        }
    };
    PostCard.prototype.SendPostcard = function () {
        var _this = this;
        if (!this.validate())
            return;
        var logObj = this.state.SenderFName + "|" + this.state.SenderLName + "|" + this.state.SenderEmail + "|" + this.state.SenderZipcode + "|" + this.state.RecipientFName + "|" + this.state.RecipientLName + "|" + this.state.RecipientAddress1 + "|" + this.state.RecipientAddress2 + "|" + this.state.RecipientCity + "|" + this.state.RecipientState + "|" + this.state.RecipientZipcode + "|" + this.state.SenderEventId;
        var queryStr = serialize({ sPostCardDetails: logObj, sRegistrantEmail: this.props.registraintEmail });
        var base_url = 'api/Registration/SendPostCardEmail';
        var init = { method: 'GET', accept: 'application/json', headers: {} };
        fetch(base_url + "?" + queryStr, init).then(function (response) { return response.json(); })
            .then(function (result) {
            if (result == true) {
                _this.props.onPostCardClose(false);
                _this.props.onSubmit(true);
                _this.Clear();
            }
        });
    };
    PostCard.prototype.handleCancel = function (e) {
        this.props.onPostCardClose(false);
    };
    PostCard.prototype.validate = function () {
        var senderfname = this.state.SenderFName;
        var senderlname = this.state.SenderLName;
        var senderemail = this.state.SenderEmail;
        var senderzipcode = this.state.SenderZipcode;
        var recipientfname = this.state.RecipientFName;
        var recipientlname = this.state.RecipientLName;
        var recipientaddress1 = this.state.RecipientAddress1;
        var recipientcity = this.state.RecipientCity;
        var recipientstate = this.state.RecipientState;
        var recipientzipcode = this.state.RecipientZipcode;
        if (senderfname === '' || senderlname === '' || senderemail === '' || senderzipcode === '' || recipientfname === '' || recipientlname === '' || recipientaddress1 === '' || recipientcity === '' || recipientstate === '' || recipientzipcode === '') {
            this.setState({ lblResult: "Please enter all the required fields." });
            return false;
        }
        if (senderemail !== '' && !this.validateEmail(senderemail)) {
            this.setState({ lblResult: senderemail + " is not valid email. Please enter valid email." });
            return false;
        }
        if (!this.validateZIP(senderzipcode)) {
            this.setState({ lblResult: senderzipcode + " is not valid ZIP Code. Please enter valid zipcode." });
            return false;
        }
        if (!this.validateZIP(recipientzipcode)) {
            this.setState({ lblResult: recipientzipcode + " is not valid ZIP Code. Please enter valid zipcode." });
            return false;
        }
        return true;
    };
    PostCard.prototype.validateEmail = function (email) {
        var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    };
    PostCard.prototype.validateZIP = function (ZIP) {
        var re = /^((\d{5}(-|\s)\d{0,4})|(\d{5}))$/;
        return re.test(ZIP);
    };
    PostCard.prototype.Clear = function () {
        this.setState({ SenderFName: '' });
        this.setState({ SenderLName: '' });
        this.setState({ SenderEmail: '' });
        this.setState({ SenderZipcode: '' });
        this.setState({ RecipientFName: '' });
        this.setState({ RecipientLName: '' });
        this.setState({ RecipientAddress1: '' });
        this.setState({ RecipientCity: '' });
        this.setState({ RecipientState: '' });
        this.setState({ RecipientZipcode: '' });
        this.setState({ SenderEventId: '' });
    };
    PostCard.prototype.render = function () {
        var _this = this;
        return (React.createElement(React.Fragment, null,
            React.createElement(reactstrap_1.Modal, { isOpen: true, className: "" },
                React.createElement(reactstrap_1.ModalHeader, { id: "AddTitle" }, "SEND A POSTCARD"),
                React.createElement(reactstrap_1.ModalBody, null,
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "regColumn" },
                            React.createElement("div", null,
                                React.createElement("strong", { style: { color: "black" } }, "Sender's Name")))),
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "regColumn" },
                            React.createElement("span", { style: { color: "Red" } }, "*"),
                            React.createElement("span", { style: { fontSize: "12px", color: "#666666" } }, "First Name:"),
                            React.createElement("input", { type: "text", name: "senderfirstname", className: "fieldcontrolguest", value: this.state.SenderFName, onChange: function (e) { _this.setState({ SenderFName: e.target.value }); }, required: true })),
                        React.createElement("div", { className: "regColumn" },
                            React.createElement("span", { style: { color: "Red" } }, "*"),
                            React.createElement("span", { style: { fontSize: "12px", color: "#666666" } }, "Last Name:"),
                            React.createElement("input", { type: "text", name: "senderlastname", className: "fieldcontrolguest", value: this.state.SenderLName, onChange: function (e) { _this.setState({ SenderLName: e.target.value }); }, required: true }))),
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "regColumn" },
                            React.createElement("span", { style: { color: "Red" } }, "*"),
                            React.createElement("span", { style: { fontSize: "12px", color: "#666666" } }, "Email:"),
                            React.createElement("input", { type: "email", name: "senderemail", className: "fieldcontrolguest", value: this.state.SenderEmail, onChange: function (e) { _this.setState({ SenderEmail: e.target.value }); }, required: true })),
                        React.createElement("div", { className: "regColumn" },
                            React.createElement("span", { className: "required" }, "*"),
                            React.createElement("span", { className: "fieldlabel1" }, "Zip Code:"),
                            React.createElement("div", null,
                                React.createElement(kendo_react_inputs_1.MaskedTextBox, { mask: "#####", name: "senderzipcode", className: "fieldcontrolguest", key: "number", id: "senderZipcode", value: this.state.SenderZipcode, onChange: function (e) { _this.setState({ SenderZipcode: e.target.value }); }, required: true })))),
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "regColumn" },
                            React.createElement("div", null,
                                React.createElement("strong", { style: { color: "black" } }, "Recipient's Name")))),
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "regColumn" },
                            React.createElement("span", { style: { color: "Red" } }, "*"),
                            React.createElement("span", { style: { fontSize: "12px", color: "#666666" } }, "First Name:"),
                            React.createElement("input", { type: "text", name: "firstname", className: "fieldcontrolguest", value: this.state.RecipientFName, onChange: function (e) { _this.setState({ RecipientFName: e.target.value }); }, required: true })),
                        React.createElement("div", { className: "regColumn" },
                            React.createElement("span", { style: { color: "Red" } }, "*"),
                            React.createElement("span", { style: { fontSize: "12px", color: "#666666" } }, "Last Name:"),
                            React.createElement("input", { type: "text", name: "lastname", className: "fieldcontrolguest", value: this.state.RecipientLName, onChange: function (e) { _this.setState({ RecipientLName: e.target.value }); }, required: true }))),
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "regColumn" },
                            React.createElement("div", null,
                                React.createElement("strong", { style: { color: "black" } }, "Recipient's Address")))),
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "regColumn" },
                            React.createElement("span", { className: "required" }, "*"),
                            React.createElement("span", { className: "fieldlabel1" }, "Address1:"),
                            React.createElement("input", { type: "text", name: "address1", className: "fieldcontrolguest", value: this.state.RecipientAddress1, onChange: function (e) { _this.setState({ RecipientAddress1: e.target.value }); }, required: true })),
                        React.createElement("div", { className: "regColumn" },
                            React.createElement("span", { className: "fieldlabel1" }, "Address2:"),
                            React.createElement("input", { type: "text", name: "address2", className: "fieldcontrolguest", value: this.state.RecipientAddress2, onChange: function (e) { {
                                    _this.setState({ RecipientAddress2: e.target.value });
                                } } }))),
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "regColumn" },
                            React.createElement("span", { className: "required" }, "*"),
                            React.createElement("span", { className: "fieldlabel1" }, "City:"),
                            React.createElement("input", { type: "text", name: "city", className: "fieldcontrolguest", value: this.state.RecipientCity, onChange: function (e) { {
                                    _this.setState({ RecipientCity: e.target.value });
                                } }, required: true })),
                        React.createElement("div", { className: "regColumn" },
                            React.createElement("span", { className: "required" }, "*"),
                            React.createElement("span", { className: "fieldlabel1" }, "State:"),
                            React.createElement("select", { "data-val": "true", name: "state", className: "fieldcontrolguest", value: this.state.RecipientState, onChange: function (e) { {
                                    _this.setState({ RecipientState: e.target.value });
                                } }, required: true }, this.state.ddlState.map(function (state) {
                                return React.createElement("option", { key: state.itemValue, value: state.itemValue }, state.itemText);
                            }))),
                        React.createElement("div", { className: "regColumn" },
                            React.createElement("span", { className: "required" }, "*"),
                            React.createElement("span", { className: "fieldlabel1" }, "Zip Code:"),
                            React.createElement("div", null,
                                React.createElement(kendo_react_inputs_1.MaskedTextBox, { mask: "#####", name: "zipcode", className: "fieldcontrolguest", key: "number", id: "recipientZipcode", value: this.state.RecipientZipcode, onChange: function (e) { {
                                        _this.setState({ RecipientZipcode: e.target.value });
                                    } }, required: true }))),
                        React.createElement("div", null,
                            React.createElement("span", { style: { color: "Red" } }, this.state.lblResult))),
                    React.createElement("div", null,
                        React.createElement("input", { type: "hidden", name: "sendereventId", value: this.state.SenderEventId }))),
                React.createElement(reactstrap_1.ModalFooter, { style: { display: "block" } },
                    React.createElement("div", { style: { textAlign: "center" } },
                        React.createElement("button", { className: "link-button6", onClick: this.SendPostcard }, "Submit"),
                        "\u00A0",
                        React.createElement("button", { className: "link-button6-grey", onClick: this.handleCancel }, "Cancel"))))));
    };
    return PostCard;
}(React.PureComponent));
exports.default = PostCard;
;
//# sourceMappingURL=PostCard.js.map